import React from 'react'
import './sidebar.css'
import TopLogo from '../Parcial/TopLogo'
import Clock from '../Parcial/Clock'
import Logout from '../Parcial/Logout'
import Navigtion from '../Parcial/Navigtion'
import Create from '../Parcial/Create'
import ClientsFilter from '../Parcial/ClientsFilter'
import SideBarClientsMob from '../Parcial/SideBarClientsMob'
import Utils from '../Parcial/Utils'

function SideBarClients() {
  return (
    <>
    <div className='sideBar'>
      <div className="sideBar2">
        <TopLogo />
        <Navigtion />
        <ClientsFilter />
        <Create />
        <Utils />
        <Clock />
        <Logout />
        </div>
    </div>
    <div className="sideBarMob">
      <SideBarClientsMob />
    </div>
    </>
  )
}

export default SideBarClients